<div class="" [class.dark-field]="darkField">
  <tui-textfield
    tuiChevron
    tuiDropdownMobile
    class="field"
    [tuiTextfieldSize]="size"
    [tuiTextfieldCleaner]="clearButton"
  >
    <label
      tuiLabel
      class="font-bold no-label-style"
      [class.label-field]="labelField"
      for="input-select"
      >{{ label ? label : placeholder }}</label
    >
    <input
      tuiComboBox
      id="input-select field"
      autocomplete="off"
      (blur)="onTouched()"
      (ngModelChange)="updateValue($event)"
      [ngModel]="displayText()"
      [disabled]="disabled"
      [placeholder]="placeholder"
    />

    <tui-data-list-wrapper
      *tuiTextfieldDropdown
      new
      [items]="itemsAsStrings$ | async | tuiFilterByInput"
    />
  </tui-textfield>

  @if (isLoading) {
    <app-loading></app-loading>
  }
</div>
